module.exports = __webpack_public_path__ + "img/flash-bg-blue.4767b51.svg";